import LocationGroupApi from '@/api/LocationGroupApi/LocationGroupApi'
import LocationGroupModel from './LocationGroup'

export default class LocationGroupRepository {
  static async getAllList(ownerProfileId, withoutEmpty = false) {
    const result = await LocationGroupApi.fetchLocationGroupList(
      ownerProfileId,
      withoutEmpty,
    )
    return result.items.map(item => item.map(LocationGroupModel.assign))
  }
  static async getList(
    ownerProfileId,
    locationGroupType,
    withoutEmpty = false,
  ) {
    const result = await LocationGroupApi.fetchLocationGroupList(
      ownerProfileId,
      locationGroupType,
      withoutEmpty,
    )
    return result.items.map(LocationGroupModel.assign)
  }

  /**
   *
   * @param {{ ownerProfileId: number, name: string, accessibleType: string }} params
   */
  static async create(params) {
    try {
      const result = await LocationGroupApi.addLocationGroup(params)
      return new LocationGroupModel(result.item)
    } catch (e) {
      throw new Error(`地点グループの登録に失敗しました：${params.name}`)
    }
  }

  static async delete(params) {
    const { id, name } = params
    try {
      await LocationGroupApi.deleteLocationGroup(id)
    } catch (e) {
      console.error(e)
      throw new Error(`地点グループの削除に失敗しました: ${name}`)
    }
  }
}
